import { render } from "./CommonTableImportForm.vue?vue&type=template&id=890a9326&scoped=true"
import script from "./CommonTableImportForm.vue?vue&type=script&lang=js"
export * from "./CommonTableImportForm.vue?vue&type=script&lang=js"

import "./CommonTableImportForm.vue?vue&type=style&index=0&id=890a9326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890a9326"]])

export default __exports__